import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

import { Typography } from "@mui/material";
import { ForgotPasswordContainer, ForgotPasswordStyledCard } from '../../Styles/Authentication/authenticationStyles';

import { useAuthenticationHook } from '../../Hooks/Authentication/authenticationHooks';

import { PasswordForgot } from '../../Models/Authentication/Authentication';

import RequiredParametersHelper from '../../Utilities/Helpers/RequiredParametersHelper';
import RequiredFieldHelper from '../../Utilities/Helpers/RequiredFieldHelper';
import RouteHelper from '../../Utilities/Helpers/RouteHelper';

import { RouteEnum } from '../../Utilities/Enums/RouteEnums';
import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import { PasswordForgotField } from '../../Utilities/Enums/ParametersEnum';

import { AssetImages } from "../../Constants/Assets";
import { StaticDisplayText } from '../../Constants/StaticDisplayTexts';

import CustomButton from '../../CustomViews/Elements/CustomButton';
import FormTextField from '../../CustomViews/Elements/FormTextField';
import AuthFooter from './AuthFooter';

export default function SignUp() {
    const navigate = useNavigate();
    const { forgotPassword } = useAuthenticationHook();
    const { enqueueSnackbar } = useSnackbar();
    let requiredFields = RequiredParametersHelper.forgotPassword();

    //Use States
    let [formData, setformData] = useState<PasswordForgot>({...new PasswordForgot() });
    const [isEmailSent, setisEmailSent] = useState(false);
    const [errorMessages, setErrorMessages]: any = useState({});

    //Variables
    const emailProps = {
        name: PasswordForgotField.USER_EMAIL,
        title: 'Email',
        placeholder: 'Enter Email Address',
        note: 'Please enter the email address to receive temporary password',
        fieldValue: formData?.[PasswordForgotField.USER_EMAIL],
        type: 'text',
        required: requiredFields?.find((field: any) => field.keyName == PasswordForgotField.USER_EMAIL)?.keyName != null,
        hideLabel: true,
        errorMessages: errorMessages,
        handleOnChange: (selectedValue: any) => {
            setformData((prev: any) => ({ ...prev, [PasswordForgotField.USER_EMAIL]: selectedValue }));
        },
    };

    //Event Handlers
    const handleSubmit = async () => {
        let _validateForm = RequiredFieldHelper.validateForm(requiredFields, formData, errorMessages, setErrorMessages, enqueueSnackbar);

        if (_validateForm?.hasError) { return true; }
        
        let forgotPasswordResponse = await forgotPassword(JSON.stringify(formData));
        let _success: boolean = forgotPasswordResponse?.isSuccess ?? false;
        
        if(_success) {
            setisEmailSent(true);
        }
    }
    //Rendering Functions
    return <ForgotPasswordContainer className='glossy-box'>
        <div className="forgotPasswordBgContainer">
            <ForgotPasswordStyledCard elevation={3}>
                <div className="forgotPasswordFormContainer">
                    <div className="formContainer">
                        <img src={AssetImages.WEB_APP_LOGO} />
                        <Typography color="primaryText" className="headerText">{RouteHelper.getRouteDescription(RouteEnum.FORGOT_PASSWORD)}</Typography>

                        {!isEmailSent && <div className="fieldsContainer">
                            <FormTextField {...emailProps} />
                        </div>}

                        {isEmailSent && <Typography color="primaryText" className="resetEmailText">Temporary password has been sent to your email.</Typography>}
                        {isEmailSent && <Typography color="primaryText" className="resetEmailText">Check your inbox for the email.</Typography>}

                        {!isEmailSent && <CustomButton
                            btnType={ButtonType.PRIMARY}
                            title='Submit'
                            className="submitBtn"
                            onClick={(e: any) => {
                                handleSubmit();
                            }} />}

                        <div className="goBackLink" onClick={() => { navigate(RouteEnum.LOGIN, { replace: true }); }}>Go Back</div>
                    </div>

                    <div className="spacer2" />
                    
                    <AuthFooter />
                </div>
            </ForgotPasswordStyledCard>
        </div>
    </ForgotPasswordContainer>
}